import React from 'react'
import {Controller} from 'react-hook-form'
import {Sponsor} from 'Event/Sponsors'
import {useConfig} from 'organization/Event/Configurable'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import ColorPicker from 'lib/ui/ColorPicker'
import BaseConfig from 'Event/Sponsors/SponsorConfig'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'

export default function SponsorConfig(props: {id: string; sponsor: Sponsor}) {
  const {sponsors, textColor} = useSimpleBlogTemplate()
  const {
    form: {control},
  } = useConfig()
  const nameColor = sponsors.nameColor ?? textColor

  return (
    <BaseConfig
      {...props}
      stylingPanel={
        <StylingPanel>
          <Controller
            name="sponsors.nameColor"
            defaultValue={nameColor}
            control={control}
            render={({value, onChange}) => (
              <ColorPicker
                label="Name Color"
                color={value}
                onPick={onChange}
                aria-label="sponsor name color"
              />
            )}
          />
        </StylingPanel>
      }
    />
  )
}
